import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios"

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: '',
        loginLocation: '',
        loginIp: ''
    },
    getters: {},
    mutations: {
        // SET_TOKEN: (state, token) => {
        //     state.token = token
        //     localStorage.setItem("token", token)
        // }
        setIp: (res) => {
            let result = res.data;
            let location = result.substring(result.indexOf("{"), result.indexOf("}") + 1);
            let json = JSON.parse(location)
            state.loginLocation = json.cname
            state.loginIp = json.cip
        }
    },
    actions: {},
    modules: {}
})
